import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function LeadsCreatedPage() {
    return (
        <OnboardingBody title='Leads created' statusText='Engagement report'>
            <p>
                Visitors who became leads after engaging or completing an action with the Chat
                widget.
            </p>
            <p>
                <em>
                    Example: A visitor starts a chat and completes an intake form, creating a lead.
                </em>
            </p>
        </OnboardingBody>
    );
}
